// extracted by mini-css-extract-plugin
export var forgotPasswordLink = "login-module--forgot-password-link--gO0pF";
export var forgotPassword__inner = "login-module--forgot-password__inner---G7io";
export var helpIcon = "login-module--help-icon--V1cGa";